import { StandardEvents } from '@shopify/events';

class GBPurchaseInfo extends HTMLElement {
  sequence = 0;
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.onProductSelect);
    this.section?.addEventListener('click', this.onVatClick);
    this.syncVat();
  }
  disconnectedCallback() {
    this.sequence++;
    this.section?.removeEventListener(StandardEvents.productSelect, this.onProductSelect);
    this.section?.removeEventListener('click', this.onVatClick);
  }
  onVatClick = (event) => {
    if (event.target instanceof Element && event.target.closest('.gb-vat-control')) queueMicrotask(() => this.syncVat());
  };
  syncVat() {
    const mode = this.section?.querySelector('.gb-vat-control')?.getAttribute('aria-pressed') === 'true' ? 'gross' : 'net';
    this.querySelectorAll('.gb-benefit-box [data-gb-vat-amount]').forEach(element => {
      const value = element.dataset[mode];
      if (value !== undefined && element.textContent !== value) element.textContent = value;
    });
  }
  onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const sequence = ++this.sequence;
    event.promise.then(({ detail }) => {
      if (sequence !== this.sequence || !this.isConnected || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const updated = detail.html.querySelector('gb-purchase-info[data-block-id="' + CSS.escape(this.dataset.blockId) + '"]') || detail.html.querySelector('gb-purchase-info[data-product-id="' + CSS.escape(this.dataset.productId) + '"]');
      if (!updated) return;
      this.replaceChildren(...Array.from(updated.childNodes, node => node.cloneNode(true)));
      this.dataset.productId = updated.dataset.productId;
      this.syncVat();
      const currentRows = document.querySelector('#gb-product-resources .gb-resources__table tbody');
      const updatedRows = detail.html.querySelector('#gb-product-resources .gb-resources__table tbody');
      if (currentRows && updatedRows) {
        currentRows.replaceChildren(...Array.from(updatedRows.childNodes, node => node.cloneNode(true)));
      }
    }).catch(error => {
      if (error?.name !== 'AbortError') console.warn('[GBPurchaseInfo]', error);
    });
  };
}
if (!customElements.get('gb-purchase-info')) customElements.define('gb-purchase-info', GBPurchaseInfo);
